import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';

import InputSsn from '../../../CommonV2/InputSsn';

/**
 * FieldInput
 * @param {*} param0
 */
const FieldInputSsn = ({ code, disabled, existError, showError, validate, handleBlur }) => (
  <Field
    component={InputSsn}
    name={code}
    disabled={disabled}
    existError={existError}
    showError={showError}
    validate={validate}
    eventEmitter={v => handleBlur(v)}
  />
);

FieldInputSsn.propTypes = {
  code: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};
FieldInputSsn.defaultProps = {
  disabled: false,
};

export default connect(FieldInputSsn);
